import React from 'react'
import { Button } from "@material-ui/core";

import {
    PopupTitle,
    PopupContainer,
    PopupDescription,
    PopupLink,
    TitleContainer
} from "../CandidateView.styles";

interface CandidateScoreInfoProps {
    onConfirm: () => void
    onLink: () => void
}

const CandidateScoreInfo = ({
    onConfirm,
    onLink,
}: CandidateScoreInfoProps) => {
    return (
        <PopupContainer>
            <TitleContainer><PopupTitle>Recommendation Score</PopupTitle></TitleContainer>
            <PopupDescription>
                <p>We use the power of 1000's of completed temping placements and reviews to calculate this Recommendation Score.</p><br/>
                <p>It's based on this candidates track record of reviews, reliability and any work history this candidate may have had with your office.</p><br/>
                <PopupLink className="no-fastclick" onClick={onLink}>Learn more about our Recommendation Engine score</PopupLink>
            </PopupDescription>
            <Button
                variant="contained"
                onClick={onConfirm}
                color="primary"
                size="large"
                id="review-button"
                className="bigButtonInNewStyle"
            >
                OK
            </Button>
        </PopupContainer>
    )
}

export default CandidateScoreInfo;
